import { InjectionToken } from "@angular/core";
import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalGuardConfiguration } from "./msal.guard.config";
import { MsalInterceptorConfig } from "./msal.interceptor.config";

export const MSAL_INSTANCE = new InjectionToken<IPublicClientApplication>("MSAL_INSTANCE");

export const MSAL_GUARD_CONFIG = new InjectionToken<MsalGuardConfiguration>("MSAL_GUARD_CONFIG");

export const MSAL_INTERCEPTOR_CONFIG = new InjectionToken<MsalInterceptorConfig>("MSAL_INTERCEPTOR_CONFIG");
